import { largeTabletMax, mobileXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import ProductsTabs from '../../tabs/ProductsTabs';
import { Heading, MidHeading, SubHeading, Text } from '../../typography';

const ROW_GAP = 30;
const COLUMN_GAP = 120;
const TAB_COLUMN_GAP = 10;
const DESKTOP_COLS = 3;

export const PageHeader = styled.section<{ hasIcons: boolean; pb?: number }>`
  background: ${({ theme }) => theme.backgroundLightest};
  padding: 40px 10px ${({ pb }) => pb || 60}px 10px;

  ${({ hasIcons }) =>
    !hasIcons
      ? css`
          @media (${largeTabletMax}) {
            padding-bottom: 40px;
          }
        `
      : ''}
`;

export const PageHeaderWrapper = styled.div<{ maxW?: number }>`
  margin: 0 auto;
  max-width: ${({ maxW }) => maxW || 1080}px;
  text-align: center;
`;

export const TabsContainer = styled.div`
  max-width: 630px;
  width: 100%;
  margin: 0 auto 75px auto;
`;

export const HeaderTitle = styled(Heading)`
  line-height: 1.1;

  @media (${mobileXLargeMax}) {
    font-size: 36px;
  }
`;

export const HeaderSubHeading = styled(SubHeading)`
  color: ${({ theme }) => theme.primary};

  @media (${mobileXLargeMax}) {
    font-size: 18px;
  }
`;

export const IconItem = styled.li<{
  maxW?: number;
  headingSize?: number;
  headingMaxW?: number;
  headingMt?: number;
  headingWeight?: string;
  textSize?: number;
  textMt?: number;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  text-align: center;

  svg,
  img {
    max-height: 70px;
    height: 100%;
  }

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ${MidHeading} {
    font-size: ${({ headingSize }) => headingSize || 44}px;

    ${({ headingMaxW }) =>
      headingMaxW
        ? css`
            margin: 0 auto;
            max-width: ${headingMaxW}px;
          `
        : ''}

    ${({ headingMt }) =>
      headingMt
        ? css`
            margin-top: ${headingMt}px;
          `
        : ''}
    
    ${({ headingWeight }) =>
      headingWeight
        ? css`
            font-weight: ${headingWeight};
          `
        : ''}
  }

  ${Text} {
    font-size: ${({ textSize }) => textSize || 20}px;

    ${({ maxW }) =>
      maxW
        ? css`
            margin: 0 auto;
            max-width: ${maxW}px;
          `
        : ''}

    ${({ textMt }) =>
      textMt
        ? css`
            margin-top: ${textMt}px;
          `
        : ''}
  }

  @media (${largeTabletMax}) and (min-width: 769px) {
    ${MidHeading} {
      font-size: ${({ headingSize }) => (headingSize && headingSize < 30 ? headingSize : 30)}px;
    }

    ${Text} {
      font-size: ${({ textSize }) => (textSize && textSize < 18 ? textSize : 18)}px;
    }
  }
`;

export const IconsGrid = styled.ul<{ rowGap?: number; columnGap?: number; iconsJustifyCenter?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  gap: ${({ rowGap }) => rowGap || ROW_GAP}px ${({ columnGap }) => columnGap || COLUMN_GAP}px;
  width: 100%;
  padding: 0;
  margin: 0 auto;

  ${IconItem} {
    flex-basis: calc(
      (100% - (${DESKTOP_COLS} - 1) * ${({ columnGap }) => columnGap || COLUMN_GAP}px) / ${DESKTOP_COLS}
    );

    @media (${tabletMax}) {
      flex-basis: 100%;
    }
  }

  @media (${largeTabletMax}) and (min-width: 769px) {
    column-gap: 10px;
    justify-content: ${({ iconsJustifyCenter }) => (iconsJustifyCenter ? 'center' : 'space-between')};
    ${IconItem} {
      flex-basis: calc((100% - (${DESKTOP_COLS} - 1) * ${TAB_COLUMN_GAP}px) / ${DESKTOP_COLS});
    }
  }

  @media (${tabletMax}) {
    row-gap: 60px;
  }
`;

export const IconContainer = styled.div`
  margin-bottom: 20px;
  svg {
    max-height: 60px;
    height: 100%;
  }
`;

export const Tabs = styled(ProductsTabs)`
  max-width: fit-content;
  margin: 0 auto;
`;
